// extracted by mini-css-extract-plugin
export default {"separate":"Home_separate__jOfxS","top_branch_slide":"Home_top_branch_slide__jXtaW","wrap_swiper":"Home_wrap_swiper__eeXoU","title":"Home_title__1aNQh"};